import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    EmailGlobalBlocklistAdd as EmailGlobalBlocklistAddMutation,
    EmailGlobalBlocklistAddVariables as EmailGlobalBlocklistAddMutationVariables,
    EmailGlobalBlocklistAddInput,
} from 'nutshell-graphql-types';

import BLOCKLIST_ADD from './mutations/email-global-blocklist-add.graphql';

export function useUpdateEmailBlocklist(): {
    onBlocklistEmail: (arg1: EmailGlobalBlocklistAddInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [emailGlobalBlocklistAdd, {loading: isLoading, error}] = useMutation<
        EmailGlobalBlocklistAddMutation,
        EmailGlobalBlocklistAddMutationVariables
    >(BLOCKLIST_ADD);

    return {
        onBlocklistEmail: (input: EmailGlobalBlocklistAddInput) =>
            emailGlobalBlocklistAdd({
                variables: {input},
            }),
        isLoading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
